<div class="card">
  <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
      <div class="dropdown me-3">
        <select id="financialYear" [formControl]="selectedFinancialYear" class="form-select">
          <option value="" selected disabled>Select Financial Year</option>
          <option *ngFor="let year of financialYears" [value]="year">{{ year }}</option>
        </select>
      </div>

      <button href="javascript:void(0);" class="btn btn-light me-2" (click)="toggleLockStatus()">
        <i *ngIf="investmentsLockedAt" class="ti ti-lock"></i>
        <i *ngIf="!investmentsLockedAt" class="ti ti-lock-open-2"></i>
      </button>
    </div>
    <div>
      <span>Tax Regime: </span>
      <span class="fw-bold">New Regime</span>
    </div>
  </div>
</div>

<div class="accordion accordionicon-left accordions-items-seperate" id="accordionSpacing">
  <div *ngFor="let section of sectionsAndSchemes; let i = index" class="accordion-item">
    <div class="accordion-header" [id]="'header' + i">
      <button
        class="accordion-button collapsed d-flex justify-content-between align-items-center"
        type="button"
        data-bs-toggle="collapse"
        [attr.data-bs-target]="'#' + i"
        aria-expanded="true"
        [attr.aria-controls]="i"
      >
        <span>{{ section.name }}</span>
        <div class="w-25">
          <div class="d-flex justify-content-between">
            <span>{{ section.limitUsed | currency: 'INR' : 'symbol' : '1.2-2' : 'en-IN' }}</span>
            <span>{{ section.maxLimit | currency: 'INR' : 'symbol' : '1.2-2' : 'en-IN' }}</span>
          </div>
          <div
            class="progress mb-3"
            role="progressbar"
            [attr.aria-valuenow]="section.limitUsed"
            [attr.aria-valuemin]="0"
            [attr.aria-valuemax]="section.maxLimit"
          >
            <div class="progress-bar" style="width: 10%">10%</div>
          </div>
        </div>

        <div class="pe-5">{{ section.schemesAppliedFor }}/{{ section.schemes.length }} Schemes</div>
      </button>
    </div>
    <div
      [id]="i"
      class="accordion-collapse collapse"
      [attr.aria-labelledby]="'header' + i"
      data-bs-parent="#accordionSpacing"
    >
      <div class="accordion-body">
        <div class="d-flex gap-2 pb-3">
          <ng-container *ngFor="let scheme of section.schemes">
            <button
              type="button"
              class="btn btn-outline-info rounded-pill"
              [disabled]="!scheme.isActive"
              (click)="addDialog(scheme)"
            >
              + {{ scheme.name }}
            </button>
          </ng-container>
        </div>
        <div class="d-flex gap-4 pb-3 flex-wrap">
          <ng-template #dialogBoxHolder></ng-template>
          <!--<app-dialog></app-dialog>-->
        </div>
      </div>
    </div>
  </div>
</div>
